module.exports = __webpack_public_path__ + "c1b4b5d3187306be460765a175c168b2.jpg";